<div class="verif-page">
    <!-- Page header (always visible) -->
    <div class="verif-header">
        <div class="verif-header-left">
            <h2 class="verif-title">Verifications</h2>
        </div>
    </div>

    <!-- Section tabs: ride photos vs operation photos -->
    <div class="verif-sections">
        <button class="verif-section" [class.verif-section--active]="!isOperationTab" (click)="setSection('ride')">
            Ride
            @if (pendingCount() > 0) {
            <span class="verif-tab-count">{{ pendingCount() }}</span>
            }
        </button>
        <button class="verif-section" [class.verif-section--active]="isOperationTab" (click)="setSection('operation')">
            Operation
            @if (operationPendingCount() > 0) {
            <span class="verif-tab-count">{{ operationPendingCount() }}</span>
            }
        </button>
    </div>

    <div class="verif-section-header">
        @if (!isOperationTab && detailsDialog && !detailsShowNav) {
        <button class="verif-back-btn" (click)="detailsDialog = false">
            <img src="assets\icons\arrow.svg" alt="Back arrow" style="transform: rotate(180deg);" />
            Back
        </button>
        }
        @if (isOperationTab) {
        <span class="verif-subtitle">
            <span>{{ operationPendingCount() }} pending</span>
            <span>·</span>
            <span>{{ operationApprovedCount() }} approved</span>
            <span>·</span>
            <span>{{ operationRejectedCount() }} rejected</span>
        </span>
        } @else if (!detailsDialog || detailsShowNav) {
        <span class="verif-subtitle">
            <span>{{ pendingCount() }} pending</span>
            <span>·</span>
            <span>{{ approvedCount() }} approved</span>
            <span>·</span>
            <span>{{ rejectedCount() }} rejected</span>
        </span>
        }
    </div>

    @if (!isOperationTab && !detailsDialog) {
    <!-- Ride photo status tabs -->
    <div class="verif-tabs">
        <button class="verif-tab verif-tab--pending" [class.verif-tab--active]="activeTab === 'PENDING'"
            (click)="setTab('PENDING')">Pending</button>
        <button class="verif-tab verif-tab--approved" [class.verif-tab--active]="activeTab === 'APPROVED'"
            (click)="setTab('APPROVED')">Approved</button>
        <button class="verif-tab verif-tab--rejected" [class.verif-tab--active]="activeTab === 'REJECTED'"
            (click)="setTab('REJECTED')">Rejected</button>
    </div>
    }

    @if (isOperationTab) {
    <app-operation-submission-list (changed)="loadOperationStats()" />
    } @else if (!detailsDialog) {
    <p-card class="mt-3">
        <app-table-component [data]="rides()" [columns]="ridesTableColumns" [totalRecords]="totalRecords()" [rows]="rows"
            [first]="first" (pageChange)="onPageChange($event)" [tableName]="''" [searchControl]="searchControl"
            [showColumnSelector]="false"
            [customFilters]="[rideStatusFilter, startedDateFilter, modelsFilter]" searchPlaceholder="Search..."
            [preserveFilterKeys]="['photoApprovalStatus']" />
    </p-card>
    } @else {
    <app-ride-verification-details
        [ride]="selectedRide"
        [photos]="endRidePhotos()!"
        [(visible)]="detailsDialog"
        [currentIndex]="selectedRideIndex"
        [total]="rides().length"
        [activeTab]="activeTab"
        [showNav]="detailsShowNav"
        (approve)="openApproveEndRidePhotos()"
        (reject)="openRejectEndRidePhotos()"
        (prev)="onDetailsPrev()"
        (next)="onDetailsNext()"
        (tabChange)="setTab($event)" />
    }
</div>

@defer (when locationDialog; prefetch on idle) {
<app-show-location-dialog [lat]="selectedRide.telemetryEndLat" [lng]="selectedRide.telemetryEndLng" [zoom]="17"
    [(visibility)]="locationDialog" />
}

@defer (when imagesCarouselDialog; prefetch on idle) {
<app-show-images-carousel-dialog [id]="selectedRide.rideId" [images]="ridePhotos" [(visibility)]="imagesCarouselDialog"
    (approve)="openApproveEndRidePhotos()" (reject)="openRejectEndRidePhotos()"
    [showApprove]="endRidePhotos()!.status === 'PENDING'" [showReject]="endRidePhotos()!.status === 'PENDING'" />
}

@defer (when approveEndRidePhotosDialog; prefetch on idle) {
<app-approve-end-ride-photos-form [selectedRide]="selectedRide" (endRidePhotosApproved)="onEndRidePhotosApproved()"
    [(visibility)]="approveEndRidePhotosDialog" />
}

@defer (when rejectEndRidePhotosDialog; prefetch on idle) {
<app-reject-end-ride-photos-form [selectedRide]="selectedRide" (endRidePhotosRejected)="onEndRidePhotosRejected()"
    [(visibility)]="rejectEndRidePhotosDialog" />
}

<!-- ── Change Photo Status Dialog ── -->
@if (changeStatusDialog && changeStatusRide) {
<div class="csd-backdrop" (click)="changeStatusDialog = false" (keyup.escape)="changeStatusDialog = false" tabindex="0" role="dialog" aria-modal="true">
    <div class="csd-modal" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()" tabindex="-1">
        <div class="csd-header">
            <span class="csd-title">Change Photo Status</span>
            <button type="button" class="csd-close" (click)="changeStatusDialog = false">✕</button>
        </div>
        <div class="csd-body">
            <div class="csd-ride-ref">Ride #{{ changeStatusRide.rideId }}</div>

            <div class="csd-field">
                <label class="csd-label" for="csd-status-select">Status</label>
                <p-select inputId="csd-status-select" [(ngModel)]="changeStatusValue" [options]="statusOptions"
                    optionLabel="label" optionValue="value"
                    placeholder="Select status" styleClass="w-full" />
            </div>

            <div class="csd-field">
                <label class="csd-label" for="csd-rejection-reason">Reason <span class="csd-optional">(optional, max 500 chars)</span></label>
                <textarea id="csd-rejection-reason" pTextarea [(ngModel)]="changeStatusReason"
                    placeholder="Enter reason..."
                    [maxlength]="500" rows="3" class="w-full csd-textarea"></textarea>
                <span class="csd-char-count">{{ changeStatusReason.length }} / 500</span>
            </div>

            @if (changeStatusError) {
            <div class="csd-error">{{ changeStatusError }}</div>
            }
        </div>
        <div class="csd-footer">
            <button type="button" class="csd-btn csd-btn--cancel" (click)="changeStatusDialog = false">Cancel</button>
            <button type="button" class="csd-btn csd-btn--save"
                [disabled]="!changeStatusValue || changeStatusLoading"
                (click)="submitChangeStatus()">
                @if (changeStatusLoading) { Saving... } @else { Save }
            </button>
        </div>
    </div>
</div>
}